<template>
  <div>
    <b-row>
      <b-col>
        <b-overlay :show="paymentloading">
          <main-title title="Seleccione el medio de pago" />

          <div class="d-flex justify-content-center flex-wrap mt-3">
            <div
              class="paymentCard shadow mt-2 mt-md-0"
              :class="{ active: paymentMethod === 1 }"
              @click="paymentMethod = 1"
            >
              <b-icon icon="credit-card" />
              <br />Transferencia bancaria
            </div>
            <div
              class="paymentCard shadow mt-2 mt-md-0"
              :class="{ active: paymentMethod === 2 }"
              @click="paymentMethod = 2"
            >
              <b-img src="@/assets/mp.png" style="margin-top: 1rem;" />
            </div>
            <div
              class="paymentCard shadow mt-2 mt-md-0"
              :class="{ active: paymentMethod === 3 }"
              @click="paymentMethod = 3"
              v-if="allowPayOnShip"
            >
              <font-awesome-icon icon="hand-holding-usd" />
              <br />Pago al retirar
            </div>
          </div>

          <div v-show="paymentMethod === 1">
            <main-title title="Datos de transferencia" />
            <div class="rounded border p-2 my-3">
              <b>Banco:</b> GALICIA
              <br />
              <b>Sucursal nº:</b> 234
              <br />
              <b>Cuenta Corriente Nº:</b> 50-5 234-3
              <br />
              <b>Titular:</b> (nombre cuenta) ASOCIACION EDUCACIONISTA ARGENTINA
              <br />
              <b>CUIT.:</b> 30-52659526-9
              <br />
              <b>CBU:</b> 007023402 0000000050535
              <br />
            </div>
            <div style="font-size: x-large; margin-bottom: .25rem;">
              Ayudanos a seguir tu operación bancaria
            </div>
            <b-row>
              <b-col class="col-12 col-md-6">
                <b-form-group
                  label="Código de transacción"
                  label-for="transanctioncode"
                  :state="formValidation.transaction"
                >
                  <b-form-input
                    id="transanctioncode"
                    v-model="formData.transanctioncode"
                    trim
                    :state="formValidation.transaction"
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col class="col-12 col-md-6">
                <b-form-file
                  placeholder="Adjunte el comprobante"
                  drop-placeholder="Arrastre el archivo aquí"
                  style="margin-top: 2rem;"
                  v-model="formData.transactionfile"
                  :state="formValidation.transaction"
                ></b-form-file>
              </b-col>
            </b-row>
          </div>
          <div v-show="paymentMethod === 2">
            <form action="" method="post" id="paymentForm">
              <main-title title="Datos del titular" />
              <b-row class="mx-0">
                <b-col>
                  <b-form-group
                    label="Nombre y apellido"
                    label-for="cardholderName"
                    :state="formValidation.cardholderName"
                  >
                    <b-input
                      type="text"
                      class="form-control"
                      id="cardholderName"
                      data-checkout="cardholderName"                    
                      :state="formValidation.cardholderName"
                    />
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row class="mx-0">
                <b-col>
                  <b-form-group label="Tipo de documento" label-for="docType">
                    <select
                      id="docType"
                      class="form-control"
                      data-checkout="docType"
                      name="docType"
                      :state="formValidation.docNumber"
                    ></select>
                  </b-form-group>
                </b-col>
                <b-col>
                  <b-form-group label="Número de documento" label-for="docNumber">
                    <b-input
                      type="text"
                      class="form-control"
                      id="docNumber"
                      name="docNumber"
                      data-checkout="docNumber"
                      :state="formValidation.docNumber"
                    />
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row class="mx-0">
                <b-col>
                  <b-form-group label="Email" label-for="email" :state="formValidation.email">
                    <b-input
                      type="email"
                      id="email"
                      name="email"
                      class="form-control"
                      :state="formValidation.email"
                    />
                  </b-form-group>
                </b-col>
              </b-row>
              <main-title title="Datos de la tarjeta" />
              <b-row class="mx-0">
                <b-col>
                  <b-form-group label="Número de la tarjeta" label-for="cardNumber" :state="formValidation.cardNumber">
                    <b-input
                      type="text"
                      id="cardNumber"
                      data-checkout="cardNumber"
                      onselectstart="return false"
                      onpaste="return false"
                      oncopy="return false"
                      oncut="return false"
                      ondrag="return false"
                      ondrop="return false"
                      autocomplete="off"
                      class="form-control"
                      :state="formValidation.cardNumber"
                    />
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row class="mx-0">
                <b-col>
                  <b-form-group
                    label="Mes de vencimiento"
                    label-for="cardExpirationMonth"
                    :state="formValidation.cardExpirationMonth"
                  >
                    <b-input
                      type="text"
                      id="cardExpirationMonth"
                      data-checkout="cardExpirationMonth"
                      onselectstart="return false"
                      onpaste="return false"
                      oncopy="return false"
                      oncut="return false"
                      ondrag="return false"
                      ondrop="return false"
                      autocomplete="off"
                      class="form-control"
                      :state="formValidation.cardExpirationMonth"
                    />
                  </b-form-group>
                </b-col>
                <b-col>
                  <b-form-group
                    label="Año de vencimiento"
                    label-for="cardExpirationYear"
                    :state="formValidation.cardExpirationYear"
                  >
                    <b-input
                      type="text"
                      id="cardExpirationYear"
                      data-checkout="cardExpirationYear"
                      onselectstart="return false"
                      onpaste="return false"
                      oncopy="return false"
                      oncut="return false"
                      ondrag="return false"
                      ondrop="return false"
                      autocomplete="off"
                      class="form-control"
                      :state="formValidation.cardExpirationYear"
                    />
                  </b-form-group>
                </b-col>
                <b-col>
                  <b-form-group label="Cód de seguridad" label-for="securityCode" :state="formValidation.securityCode">
                    <b-input
                      type="text"
                      id="securityCode"
                      data-checkout="securityCode"
                      onselectstart="return false"
                      onpaste="return false"
                      oncopy="return false"
                      oncut="return false"
                      ondrag="return false"
                      ondrop="return false"
                      autocomplete="off"
                      class="form-control"
                      size="3"
                      :state="formValidation.securityCode"
                    />
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row class="mx-0">
                <b-col>
                  <b-form-group label="Banco emisor" label-for="issuer">
                    <select id="issuer" class="form-control" name="issuer" data-checkout="issuer"></select>
                  </b-form-group>
                </b-col>
                <b-col>
                  <b-form-group label="Cuotas" label-for="installments">
                    <select
                      id="installments"
                      class="form-control"
                      name="installments"
                    ></select>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row class="mx-0">
                <b-col class="text-right">
                  <input type="hidden" name="transactionAmount" id="transactionAmount" :value="(calcSubtotal() + shipCost) - formData.couponDiscount" />
                  <input type="hidden" name="paymentMethodId" id="paymentMethodId" />
                  <input type="hidden" name="description" id="description" />
                </b-col>
              </b-row>
            </form>
          </div>
          <div v-show="paymentMethod === 3" style="text-align: center;">
            <b-alert show class="mt-5"
              >El producto será reservado por 15 días a partir del momento de
              confirmación de la compra. Pasado ese tiempo, si no fue reclamado,
              volverá al stock.</b-alert
            >
          </div>
          <b-row class="mt-3">
            <b-col>
              <div style="font-size: x-large; margin-bottom: .25rem;">
                ¡Tengo un cupón de descuento!
              </div>
            </b-col>
          </b-row>
          <b-row class>
            <b-col>
              <b-form-group
                label="Escriba el nombre del cupón y/o descuento"
                label-for="discount"
              >
                <b-form-input
                  id="discount"
                  v-model="formData.coupon"
                  trim
                  :disabled="formData.validatedCoupon"
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col cols="auto" class="pt-4 pt-md-0">
              <b-button v-if="!formData.validatedCoupon" style="margin-top: 2rem;" @click="validateCoupon">Validar</b-button>
              <b-button v-if="formData.validatedCoupon" style="margin-top: 2rem;" @click="resetCoupon">Quitar</b-button>
            </b-col>
          </b-row>
          <b-row v-if="couponMessage !== null">
            <b-col>
              <b-alert show :variant="couponMessage.variant" v-html="couponMessage.text"></b-alert>
            </b-col>
          </b-row>
        </b-overlay>
      </b-col>
      <b-col class="col-12 col-md-3">
        <div
          class="d-flex flex-column justify-content-between p-4"
          style="background: #F1F1F1; font-family: 'Poppins', sans-serif; border-radius: 2rem; min-height: 100%;"
        >
          <div>
            <div style="margin-top: -3rem;">
              <main-title title="Detalle" />
            </div>
            <b-list-group flush style="font-size: small;">
              <b-list-group-item
                class="d-flex pt-4 px-0 border-bottom-0"
                style="background-color: transparent;"
              >
                <div>Su compra</div>
                <div class="ml-auto" style="font-weight: bold;">$ {{ calcSubtotal() + discounts }}</div>
              </b-list-group-item>
              <b-list-group-item
                class="d-flex px-0 pt-0 border-bottom-0"
                style="background-color: transparent; font-size: .7rem;"
                v-if="discounts > 0"
              >
                <div class="ml-3">Descuentos</div>
                <div class="ml-auto" style="font-weight: bold;">- $ {{discounts}}</div>
              </b-list-group-item>

              <b-list-group-item
                class="d-flex px-0 pt-0"
                style="background-color: transparent; font-size: .7rem;"
              >
                <div class="ml-3">Peso total</div>
                <div class="ml-auto" style="font-weight: bold;">{{shipWeight}} gr</div>
              </b-list-group-item>

              <b-list-group-item
                class="d-flex px-0"
                style="background-color: transparent;"
              >
                <div>Valor del envío</div>
                <div class="ml-auto" style="font-weight: bold;">
                  $ {{ shipCost }}
                </div>
              </b-list-group-item>
              
              <b-list-group-item
                class="d-flex px-0"
                style="background-color: transparent;"
                v-if="formData.validatedCoupon"
              >
                <div>Cupón</div>
                <div class="ml-auto" style="font-weight: bold;">- ${{formData.couponDiscount}}</div>
              </b-list-group-item>
              
              <b-list-group-item
                class="d-flex pt-4 px-0"
                style="font-weight: bold; background-color: transparent;"
              >
                <div>Total</div>
                <div class="ml-auto">$ {{ (calcSubtotal() + shipCost) - formData.couponDiscount }}</div>
              </b-list-group-item>
            </b-list-group>
          </div>
        </div>
      </b-col>
    </b-row>
    <div class="d-flex mx-2 mb-2 mt-4">
      <div
        class="rounded py-2 px-4 d-flex justify-content-between flex-fill subtotal-line"
        style="background: #f1f1f1;"
      >
        <div>Total</div>
        <div class="d-none d-md-block">{{ cart }} items</div>
        <div>${{ (calcSubtotal() + shipCost) - formData.couponDiscount}}</div>
      </div>
      <b-button
        size="sm"
        class="ml-3"
        style="background: #e8661a; border:none; line-height: 2rem; font-size: 1em;"
        @click="saveData()"
        >Siguiente</b-button
      >
    </div>
  </div>
</template>
<script>
import MainTitle from "@/components/MainTitle.vue";
import { mapState, mapGetters } from "vuex";
import axios from "axios";

export default {
  components: {
    MainTitle
  },
  data: function() {
    return {
      formData: {
        transanctioncode: "",
        transactionfile: null,
        couponDiscount: 0,
        validatedCoupon: false,
        coupon: ""
      },
      formValidation:{
        cardNumber: null,
        cardExpirationMonth: null,
        cardExpirationYear: null,
        securityCode: null,
        cardholderName: null,
        docNumber: null,
        email: null,
        transaction: null
      },
      shipCost: 0,
      shipWeight: 0,
      discounts: 0,
      paymentMethod: 0,
      paymentloading: false,
      allowPayOnShip: true,
      couponMessage: null
    };
  },
  mounted(){
    if (this.$parent.formData.step1){
      this.shipWeight = this.$parent.formData.step1.peso;
      //  this.discounts = Math.round( (this.$parent.formData.step1.discounts * 100) /  this.$parent.formData.step1.precio )
      this.discounts = this.$parent.formData.step1.discounts;
    }else{
     this.$router.push('/cart/step1');
    }
    if (this.$parent.formData.step3 && this.$parent.formData.step3.type){
      this.shipCost = this.$parent.formData.step3.type.cost;
      if (this.$parent.formData.step3.type.cost !== 0){
        this.allowPayOnShip = false;
      }
    }
    // window.Mercadopago.setPublishableKey("TEST-d797344a-5b12-4515-845f-310c829b8dee");
    window.Mercadopago.setPublishableKey("APP_USR-0e554f79-881a-4e5e-a403-f4811fcf2899");
    window.Mercadopago.getIdentificationTypes();
    document.getElementById('cardNumber').addEventListener('change', guessPaymentMethod);

      function guessPaymentMethod(event) {
        const cardnumber = document.getElementById("cardNumber").value;
        if (cardnumber.length >= 6) {
            const bin = cardnumber.substring(0,6);
            window.Mercadopago.getPaymentMethod({
                "bin": bin
            }, setPaymentMethod);
        }
      };

      function setPaymentMethod(status, response) {
        if (status === 200) {
            const paymentMethod = response[0];
            document.getElementById('paymentMethodId').value = paymentMethod.id;

            if(paymentMethod.additional_info_needed.includes("issuer_id")){
                getIssuers(paymentMethod.id);
                document.getElementById('issuer').disabled = false
            } else {
                document.getElementById('issuer').disabled = true
                getInstallments(
                    paymentMethod.id,
                    document.getElementById('transactionAmount').value
                );
            }
        } else {
            console.log('payment method info error:', response);
            alert(`Error: El número de tarjeta no es válido`);
        }
      }

      function getIssuers(paymentMethodId) {
        window.Mercadopago.getIssuers(
            paymentMethodId,
            setIssuers
        );
      }

      function setIssuers(status, response) {
        if (status === 200) {
            const issuerSelect = document.getElementById('issuer');
            response.forEach( issuer => {
                const opt = document.createElement('option');
                opt.text = issuer.name;
                opt.value = issuer.id;
                issuerSelect.appendChild(opt);
            });

            getInstallments(
                document.getElementById('paymentMethodId').value,
                document.getElementById('transactionAmount').value,
                issuerSelect.value
            );
        } else {
            alert(`issuers method info error: ${response}`);
        }
      }

      function getInstallments(paymentMethodId, transactionAmount, issuerId){
        window.Mercadopago.getInstallments({
            "payment_method_id": paymentMethodId,
            "amount": parseFloat(transactionAmount),
            "issuer_id": issuerId ? parseInt(issuerId) : undefined
        }, setInstallments);
      }

      function setInstallments(status, response){
        if (status === 200) {
            document.getElementById('installments').options.length = 0;
            response[0].payer_costs.forEach( payerCost => {
                const opt = document.createElement('option');
                opt.text = payerCost.recommended_message;
                opt.value = payerCost.installments;
                document.getElementById('installments').appendChild(opt);
            });
        } else {
            alert(`installments method info error: ${response}`);
        }
      }

  },
  computed: {
    ...mapState({
      cartItems: state => state.cart.cartItems
    }),
    ...mapGetters({ cart: "countCartItems" })
  },
  methods: {
    getBookCost: function(itemType) {
      switch (parseInt(itemType)) {
        case 1:
          return 700;
        case 2:
          return 500;
        case 3:
          return 50;
      }
    },
    calcSubtotal: function() {
       let result = 0;
      if (this.$parent.formData.step1){
        result = this.$parent.formData.step1.precio;
      }
      return result;
    },
    validateCoupon () {
      axios
        .post(
          this.$store.state.user.siteData.location + 'items/coupons/validate',
          JSON.stringify({ coupon: this.formData.coupon, client: this.$store.state.user.usrid }),
            {
                validateStatus(status) {
                return status < 500; // Resolve only if the status code is less than 500
                },
                headers: {
                "Content-Type": "application/json"
                }
            }
        )
        .then((evtResponse) => {
          console.log(evtResponse);
          const result = evtResponse.data.records;
          let couponInfo = '';

          if (result.length === 0) {
            this.couponMessage = {
              variant: 'danger',
              text: 'El cupón ingresado no existe o no pertenece a una promoción activa.'
            }
            this.formData.validatedCoupon = false;
            return false;
          }
          if (parseInt(result[0].codeUses) >= parseInt(result[0].uses)){
            this.couponMessage = {
              variant: 'danger',
              text: 'Este cupón ya fue usado, intentá con otro.'
            }
            this.formData.validatedCoupon = false;
            return false;
          }
          if (parseInt(result[0].stock) > 0 && parseInt(result[0].totaluses) >= parseInt(result[0].stock)){
            this.couponMessage = {
              variant: 'danger',
              text: 'El cupón ingresado ha superado el límite de stock.'
            }
            this.formData.validatedCoupon = false;
            return false;
          }
          if (result[0].codeClient !== null && result[0].codeClient !== this.$store.state.user.usrid){
            this.couponMessage = {
              variant: 'danger',
              text: 'El cupón ingresado pertenece a otro cliente registrado.'
            }
            this.formData.validatedCoupon = false;
            return false;
          }
          if (result[0].precode !== null && result[0].precode !== result[0].codeID){
            this.couponMessage = {
              variant: 'danger',
              text: 'El cupón ingresado pertenece a otro cliente registrado.'
            }
            this.formData.validatedCoupon = false;
            return false;
          }
          if (result[0].rules !== null && result[0].rules.length > 0) {
            const validationRules = {};
            result[0].rules.forEach((element) => {
              if (element.var === 'price'){
                const validatePrice = this.$parent.formData.step1.precio + this.shipCost;
                if (validationRules.price === undefined) {
                  validationRules.price = [];
                }
                if (element.type === 1 && validatePrice === parseInt(element.value)) {
                  validationRules.price.push(true);
                } else if (element.type === 2 && validatePrice <= parseInt(element.max) && validatePrice >= parseInt(element.min)) {
                  validationRules.price.push(true);
                } else {
                  validationRules.price.push(false);
                }
              } else if (element.var === 'weigth'){
                const validateWeigth = this.$parent.formData.step1.peso;
                if (validationRules.weigth === undefined) {
                  validationRules.weigth = [];
                }
                if (element.type === 1 && validateWeigth === parseInt(element.value)) {
                  validationRules.weigth.push(true);
                } else if (element.type === 2 && validateWeigth <= parseInt(element.max) && validateWeigth >= parseInt(element.min)) {
                  validationRules.weigth.push(true);
                } else {
                  validationRules.weigth.push(false);
                }
              } else {
                const validateVar = this.$parent.formData.step3.addressInfo[element.var];
                if (validationRules[element.var] === undefined) {
                  validationRules[element.var] = [];
                }
                if (element.type === 1 && validateVar === element.value) {
                  validationRules[element.var].push(true);
                } else if (element.type === 2 && parseFloat(validateVar) <= parseFloat(element.max) && parseFloat(validateVar) >= parseFloat(element.min)) {
                  validationRules[element.var].push(true);
                } else {
                  validationRules[element.var].push(false);
                }
              }
            })
            let validationResult = true;
            for (const validationVar in validationRules){
              let validationVarResult = false;
              validationRules[validationVar].forEach((element) => {
                if (element === true) {
                  validationVarResult = true
                }
              })
              if (validationVarResult === false) {
                validationResult = false
              }
            }
            console.log(validationRules, validationResult);
            if (validationResult === false) {
              this.couponMessage = {
                variant: 'danger',
                text: 'El cupón ingresado no existe o no pertenece a una promoción activa.'
              }
              this.formData.validatedCoupon = false;
              return false;
            }
          }
          let accept = false;
          const includeBooks = [];
          const includeBooksText = [];
          let prices = 0;
          if (result[0].books.length === 0) {
            accept = true;
            prices = this.$parent.formData.step1.precio;
          } else {
            this.cartItems.forEach((element) => {
              if (element.type === 1){
                result[0].books.forEach((bookItem) => {
                  if (parseInt(bookItem.id) === element.id) {
                    includeBooks.push({
                      id: element.id,
                      quantity: element.quantity
                    })
                    includeBooksText.push('<b>' + bookItem.title + '</b>');
                    prices += parseInt(bookItem.price) * element.quantity;
                  }
                })
              }
            })
            if (includeBooks.length > 0) {
              accept = true;
            }
          }
          if (!accept){
            this.couponMessage = {
              variant: 'danger',
              text: 'Este cupón solo aplica a determinados libros que no se encuentran en tu carrito, intentá con otro.'
            }
            this.formData.validatedCoupon = false;
            return false;
          }

          if (result[0].scope === '0') {
            if (result[0].discounttype === '1') {
              this.formData.couponDiscount = parseInt(result[0].discountvalue);
              couponInfo = 'de $' + result[0].discountvalue + ' ha sido aplicado sobre toda la compra.';
            } else {
              this.formData.couponDiscount = ((this.$parent.formData.step1.precio + this.shipCost) * parseInt(result[0].discountvalue)) / 100;
              couponInfo = 'del ' + result[0].discountvalue + '% ha sido aplicado sobre toda la compra.';
            }
          }
          if (result[0].scope === '1') {
              if (result[0].discounttype === '1') {
                this.formData.couponDiscount = parseInt(result[0].discountvalue);
                couponInfo = 'de $' + result[0].discountvalue + ' ha sido aplicado sobre ';
              } else {
                this.formData.couponDiscount = (prices * parseInt(result[0].discountvalue)) / 100;
                couponInfo = 'del ' + result[0].discountvalue + '% ha sido aplicado sobre ';
              }
              if (includeBooks.length > 0) {
                if (includeBooks.length === 1) {
                  couponInfo += 'el libro ';
                } else {
                  couponInfo += 'los libros ';
                }
                couponInfo += includeBooksText.join(', ') + ' ';
                couponInfo += '.';
              } else {
                couponInfo += 'los libros que se encuentran en tu carrito.';
              }
          }
          if (result[0].scope === '2') {
            if (this.shipCost <= 0 || this.shipCost === null) {
              this.couponMessage = {
                variant: 'danger',
                text: 'El cupón no aplica al tipo de envío seleccionado.'
              }
              this.formData.validatedCoupon = false;
              return false;
            }
            if (result[0].discounttype === '1') {
              this.formData.couponDiscount = parseInt(result[0].discountvalue);
              couponInfo = 'de $' + result[0].discountvalue + ' ha sido aplicado sobre el valor del envío.';
            } else {
              this.formData.couponDiscount = ((this.shipCost) * parseInt(result[0].discountvalue)) / 100;
              couponInfo = 'del ' + result[0].discountvalue + '% ha sido aplicado sobre el valor del envío.';
              if (parseInt(result[0].discountvalue) === 100) {
                couponInfo = 'de envío gratis ha sido aplicado.';
              }
            }
          }
          if (this.discounts > 0) {
            this.couponMessage = {
              variant: 'danger',
              text: 'Este cupón no se puede utilizar si ya hay un descuento activo.'
            }
            this.formData.validatedCoupon = false;
            return false;
          }

          this.formData.couponDiscount = Math.round(this.formData.couponDiscount);
          this.couponMessage = {
            variant: 'success',
            text: 'El cupón '+couponInfo
          }
          this.formData.validatedCoupon = true;
        });
    },
    resetCoupon () {
      this.formData.validatedCoupon = false;
      this.couponMessage = null;
      this.formData.couponDiscount = 0;
      this.formData.coupon = "";
    },
    saveData(){
      if (this.paymentMethod === 0){
        this.$bvModal.msgBoxOk('Debe seleccionar un medio de pago para continuar la compra', {
            title: 'Error',
            size: 'sm',
            buttonSize: 'sm',
            okVariant: 'success',
            headerClass: 'p-2 border-bottom-0',
            footerClass: 'p-2 border-top-0',
            centered: true
            });
          
          return;
      }else if (this.paymentMethod === 1){
        if (this.formData.transanctioncode === '' && this.formData.transactionfile === null){
          this.formValidation.transaction = false;
          this.$bvModal.msgBoxOk('Ingrese al menos un canal de seguimiento de la transacción', {
            title: 'Error',
            size: 'sm',
            buttonSize: 'sm',
            okVariant: 'success',
            headerClass: 'p-2 border-bottom-0',
            footerClass: 'p-2 border-top-0',
            centered: true
            });
          
          return;
        }

      }else if (this.paymentMethod === 2){      
      
        let validForm = true;
        
        for(const field in this.formValidation){
          if (document.getElementById(field) !== null){
            if (document.getElementById(field).value.trim() === ''){
              this.formValidation[field] = false;
              validForm = false;
            }else{
              this.formValidation[field] = true;
            }
          }
        }

        if (!validForm){
          this.$bvModal.msgBoxOk('Debe completar todos los datos para continuar la compra', {
            title: 'Error',
            size: 'sm',
            buttonSize: 'sm',
            okVariant: 'success',
            headerClass: 'p-2 border-bottom-0',
            footerClass: 'p-2 border-top-0',
            centered: true
            });
          
          return;
        }
        this.paymentloading = true;

        const $form = document.getElementById('paymentForm');
        window.Mercadopago.createToken($form, this.setCardTokenAndPay);

        return;
      }

      console.log('Cambiar paso');
      this.completeRequest();

    },
    setCardTokenAndPay (status, response) {
        if (status === 200 || status === 201) {
            const form = document.getElementById('paymentForm');
            const card = document.createElement('input');
            card.setAttribute('name', 'token');
            card.setAttribute('type', 'hidden');
            card.setAttribute('value', response.id);
            form.appendChild(card);
            
            console.log(status, response);

            console.log('Mandar form');
            
            const formData = new FormData(form);

            
            axios
            .post(
              this.$store.state.user.siteData.location + 'payment',
              formData,
              {
                validateStatus(status) {
                  return status < 500 // Resolve only if the status code is less than 500
                },
                headers: {
                  'Content-Type': 'multipart/form-data',
                },
              }
            )
            .then((evtResponse) => {
              console.log(evtResponse);
              if (evtResponse.data.status === 'approved'){
                console.log('Cambiar paso');
                this.completeRequest();
              } else if(evtResponse.data.status === 'in_process'){
                alert("Estamos procesando tu pago.\nNo te preocupes, menos de 2 días hábiles te avisaremos por e-mail si se acreditó o si necesitamos más información.");
                console.log('Cambiar paso');
                this.completeRequest();
              } else{
                this.paymentloading = false;
                let msg = 'Ha ocurrido un error procensado el pago: ';
                switch(evtResponse.data.status_detail){
                     case "cc_rejected_bad_filled_card_number": msg +='Revisa el número de tarjeta.'; break;
                     case "cc_rejected_bad_filled_date": msg +='Revisa la fecha de vencimiento.'; break;
                     case "cc_rejected_bad_filled_other": msg +='Revisa los datos.'; break;
                     case "cc_rejected_bad_filled_security_code": msg +='Revisa el código de seguridad de la tarjeta.'; break;
                     case "cc_rejected_blacklist": msg +='No pudimos procesar tu pago.'; break;
                     case "cc_rejected_call_for_authorize": msg +='Debes autorizar el pago en la entidad emisora de la tarjeta.'; break;
                     case "cc_rejected_card_disabled": msg +='Llama a la entidad emisora de la tarjeta para activar tu tarjeta o usa otro medio de pago. El teléfono está al dorso de tu tarjeta.'; break;
                     case "cc_rejected_card_error": msg +='No pudimos procesar tu pago.'; break;
                     case "cc_rejected_duplicated_payment": msg +='Ya hiciste un pago por ese valor. Si necesitas volver a pagar usa otra tarjeta u otro medio de pago.'; break;
                     case "cc_rejected_high_risk": msg +='Tu pago fue rechazado. Elige otro de los medios de pago, te recomendamos con medios en efectivo.'; break;
                     case "cc_rejected_insufficient_amount": msg +='Tu tarjeta no tiene fondos suficientes.'; break;
                     case "cc_rejected_invalid_installments": msg +='Tu tarjeta no procesa pagos en esa cantidad de cuotas.'; break;
                     case "cc_rejected_max_attempts": msg +='Llegaste al límite de intentos permitidos. Elige otra tarjeta u otro medio de pago.'; break;
	                   case "cc_rejected_other_reason": msg +='Tu tarjeta no procesó el pago.'; break;
                     default: msg += "Error desconocido";
                }
                alert(msg);
                card.remove();
              }
            });
            
            

        } else {
            this.paymentloading = false;
            console.log('Token error: ', response);
            let msg = 'Ha ocurrido un error en los datos ingresados: ';
            response.cause.forEach(element => {
              switch(element.code){
                case 'E301': 
                  msg += "\nNúmero de tarjeta inválido."; 
                  this.formValidation.cardNumber = false;
                break;
                case 'E302': 
                  msg += "\nCódigo de seguridad inválido.";
                  this.formValidation.securityCode = false; 
                break;
                case '316': 
                  msg += "\nNombre del titular inválido.";
                  this.formValidation.cardholderName = false; 
                break;
                case '322': 
                  msg += "\nEl tipo de documento es inválido."; 
                  this.formValidation.docNumber = false;
                break;
                case '323': 
                  msg += "\nRevisa tu documento."; 
                  this.formValidation.docNumber = false;
                break;
                case '324': 
                  msg += "\nEl documento es inválido.";
                  this.formValidation.docNumber = false; 
                break;
                case '325': 
                  msg += "\nEl mes es inválido."; 
                  this.formValidation.cardExpirationMonth = false;
                break;
                case '326': 
                  msg += "\nEl año es inválido."; 
                  this.formValidation.cardExpirationYear = false;
                break;
                default: msg += "\n" + element.description;
              }
            });
            alert(msg);
        }
      },
    completeRequest (){
        this.paymentloading = true;
        
        const formData = new FormData()
        
        for ( var key in this.$parent.formData.step3 ) {
            if (key === 'type'){
              formData.append(key, this.$parent.formData.step3.type.id);
              formData.append('deliverycost', this.$parent.formData.step3.type.cost);
            } else if (key !== 'addresscords'){
              formData.append(key, this.$parent.formData.step3[key]);
            }
            
        }
        
        let postalCode = '';
        let postalCodeSufix = '';
        if (this.$parent.formData.step3.addresscp){
          postalCode = this.$parent.formData.step3.addresscp;
        }else{
          if (this.$parent.formData.step3.addresscords.address_components){
            this.$parent.formData.step3.addresscords.address_components.forEach((element) => {
              if (element.types.includes('postal_code')){
                postalCode = element.short_name
              } else if (element.types.includes('postal_code_suffix')){
                postalCodeSufix = element.short_name
              }
            });
          }
        }
        console.log(postalCode, postalCodeSufix);

        let deliveryaddress = {};

        if (postalCode === '') {
          deliveryaddress = {
            lat: this.$parent.formData.step3.addresscords.lat,
            lng: this.$parent.formData.step3.addresscords.lng,
            text: this.$parent.formData.step3.addresscords.text,
            addressdetails: this.$parent.formData.step3.addressdetails
          };
        } else {
          deliveryaddress = {
            lat: this.$parent.formData.step3.addresscords.lat,
            lng: this.$parent.formData.step3.addresscords.lng,
            text: this.$parent.formData.step3.addresscords.text,
            addressdetails: this.$parent.formData.step3.addressdetails,
            cp:  postalCode + postalCodeSufix 
          };
        }

        formData.append('deliveryaddress', JSON.stringify(deliveryaddress));

        formData.append('transactionnumber',this.formData.transanctioncode);
        formData.append('file',this.formData.transactionfile);
        formData.append('paymentMethod',this.paymentMethod);
        formData.append('client',this.$store.state.user.usrid);
        
        formData.append('items', JSON.stringify(this.cartItems));
        /*

        formData.append('file', imagefile.files[0])
        formData.append('repository', 'books')
        formData.append('name', this.bookDataLocal.id + '_' + img)

        */
        if (this.formData.validatedCoupon) {
          formData.append('coupon', this.formData.coupon);
          formData.append('couponDiscount', this.formData.couponDiscount);
        }

        axios
            .post(
              this.$store.state.user.siteData.location + 'orders/orders/add',
               formData,
              {
                validateStatus(status) {
                  return status < 500 // Resolve only if the status code is less than 500
                },
                headers: {
                  'Content-Type': 'multipart/form-data',
                },
              }
            )
            .then((evtResponse) => {
              this.paymentloading = false;
              console.log(evtResponse);
              if (evtResponse.data.result === '1'){
                this.$router.push('/cart/step5');
              }
            });
        
    }
  }
};
</script>
